import { Bank, MotorSynthPresets, Preset } from "./types"
import { v4 as uuidv4 } from 'uuid';

const MAX_SLOTS = 128;
const MAX_NAME_LENGTH = 20;
const DEFAULT_BANK_NAME = (i: number) => `Bank${i}`.toUpperCase();

const addPreset = (bank: Bank, preset: Preset) => {
    const slot = findEmptySlot(bank);
    if (slot === -1) {
        throw Error(`The bank '${bank.name}' is full.`)
    }
    bank.presets[slot] = preset;
    if (!bank.name) {
        bank.name = DEFAULT_BANK_NAME(slot);
    }
};

const getPresetCount = (bank: Bank) => bank.presets.filter(p => p !== undefined).length;

const isEmpty = (bank: Bank) => bank.presets.every(p => p === undefined);

const isFull = (bank: Bank) => getPresetCount(bank) === MAX_SLOTS;

const insertPreset = (bank: Bank, preset: Preset, slot: number) => {
    // TODO: refactor this, once arrays are dynamic not static 128 size
    if (slot < 0 || slot > MAX_SLOTS) {
        throw Error(`The slot '${slot}' is out of range.`)
    }
    if (isFull(bank)) {
        throw Error(`The bank '${bank.name}' is full.`)
    }
    delete bank.presets[findEmptySlot(bank)];
    bank.presets.splice(slot, 0, preset);

}

const findPreset = (bank: Bank, preset: Preset) => bank.presets.findIndex(p => p?.uniqueId === preset.uniqueId);

const removePreset = (bank: Bank, preset: Preset) => {
    const slot = findPreset(bank, preset);
    if (slot === -1) {
        throw Error(`The preset '${preset.name}' does not exist in the bank '${bank.name}'.`)
    }
    return bank.presets.splice(slot, 1)[0]!;
};


const containsPreset = (bank: Bank, preset: Preset) => findPreset(bank, preset) !== -1;

const findEmptySlot = (bank: Bank) => bank.presets.findIndex(p => p === undefined);

const createEmptyTree = (): MotorSynthPresets => ({
    banks: [...Array(MAX_SLOTS)].map(() => ({
      name: '',
      presets: [...Array(MAX_SLOTS)],
      uniqueId: uuidv4(),
    })),
  });

const Mspr = {
    MAX_SLOTS,
    MAX_NAME_LENGTH,
    DEFAULT_BANK_NAME,
    createEmptyTree,
    addPreset,
    insertPreset,
    removePreset,
    containsPreset,
    findPreset,
    isEmpty,
    isFull,
    getPresetCount,
    findEmptySlot,
}

export default Mspr;